import React from 'react';
import {observer} from 'mobx-react';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import Translate from '../../components/translate/Translate';
import {requireImage} from '../../utils/utils';
import {ThankYouModalController} from './ThankYouModal.controller';
import './ThankYouModal.scss';

interface ThankYouModalProps {
    ctrl: ThankYouModalController;
}

const Header = ({dir}: {dir?: string}) => {
    return (
        <div className='thank-you-modal-header' dir={dir}>
            <img src={requireImage('smile-icon.png')} alt='Thank you' />
        </div>
    );
};

const Content = ({dir}: {dir?: string}) => {
    return (
        <div className='thank-you-modal-body' dir={dir}>
            <h4>
                <Translate text='DASHBOARD.SURVEY.THANK_YOU' />
            </h4>
        </div>
    );
};

const Footer = ({dir}: {dir?: string}) => {
    return <div className='thank-you-modal-footer' dir={dir}></div>;
};

@observer
export class ThankYouModal extends React.Component<ThankYouModalProps> {
    render() {
        const {ctrl} = this.props;
        const {isVisible, dir} = ctrl;

        return (
            <GenericModal
                className='modal-dialog thank-you-dialog custom-thank-you-styles'
                header={() => <Header dir={dir} />}
                content={() => <Content dir={dir} />}
                toolbar={() => <Footer dir={dir} />}
                show={isVisible}
                onHideHandler={() => ctrl.close()}
            />
        );
    }
}
